module.exports = __webpack_public_path__ + "img/1-8167.77f53395.png";